"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawQuery = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const prismjs_1 = tslib_1.__importDefault(require("prismjs"));
const react_1 = tslib_1.__importDefault(require("react"));
const data_1 = require("@grafana/data");
const ui_1 = require("@grafana/ui");
function RawQuery({ query, language, className }) {
    const theme = (0, ui_1.useTheme2)();
    const styles = getStyles(theme);
    const highlighted = prismjs_1.default.highlight(query, language.grammar, language.name);
    return (react_1.default.createElement("div", { className: (0, css_1.cx)(styles.editorField, 'prism-syntax-highlight', className), "aria-label": "selector", dangerouslySetInnerHTML: { __html: data_1.textUtil.sanitize(highlighted) } }));
}
exports.RawQuery = RawQuery;
const getStyles = (theme) => {
    return {
        editorField: (0, css_1.css)({
            fontFamily: theme.typography.fontFamilyMonospace,
            fontSize: theme.typography.bodySmall.fontSize,
        }),
    };
};
//# sourceMappingURL=RawQuery.js.map